import axios from "axios";

async function Axi() {
  try {
    //응답 성공
    const response = await axios.post(
      "https://accounts.google.com/o/oauth2/token",
      {
        //보내고자 하는 데이터
        client_id:
          "382288712795-7pfg7nc8v5tjlvp1k58151n77ekn4a58.apps.googleusercontent.com",
        client_secret: process.env.REACT_APP_CLIENT_SECRET,
        refresh_token: process.env.REACT_APP_REFRESH_TOKEN,
        grant_type: "refresh_token",
      }
    );
    const access_token = response.data.access_token;
    const url =
      "https://www.googleapis.com/analytics/v3/data/ga?access_token=" +
      access_token +
      "&ids=ga%3A265023678&dimensions=ga%3Adate&metrics=ga%3Ausers%2Cga%3Asessions%2Cga%3Apageviews&start-date=2022-04-16&end-date=today";
    const res = await fetch(url);
    const data = await res.json();
    return data;
  } catch (error) {
    //응답 실패
    console.error(error);
  }
}
export default Axi;
